export default __webpack_public_path__ + "static/media/ekockp.458659e9.png";